import { render, staticRenderFns } from "./ShowQyMemM.vue?vue&type=template&id=8b06d04e&scoped=true&"
import script from "./ShowQyMemM.vue?vue&type=script&lang=js&"
export * from "./ShowQyMemM.vue?vue&type=script&lang=js&"
import style0 from "./ShowQyMemM.vue?vue&type=style&index=0&id=8b06d04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b06d04e",
  null
  
)

component.options.__file = "ShowQyMemM.vue"
export default component.exports